import { InitialTheme } from './types';
import { createTheme } from './helpers';

const initialTheme: InitialTheme = {
  borderRadius: {
    sm: '3px',
    md: '6px',
    lg: '50px',
  },
  boxShadows: {
    primary: (() => {
      const PRIMARY_BOX_SHADOW_COLOR = 'rgb(0, 0, 0)';
      const SECONDARY_BOX_SHADOW_COLOR = 'rgba(235, 236, 240, .5)';

      return {
        primaryColor: PRIMARY_BOX_SHADOW_COLOR,
        secondaryColor: SECONDARY_BOX_SHADOW_COLOR,
        main: `${PRIMARY_BOX_SHADOW_COLOR} 2px 2px 4px, ${SECONDARY_BOX_SHADOW_COLOR} 0px 0px 5px`,
        inset: `inset ${PRIMARY_BOX_SHADOW_COLOR} 2px 2px 4px, ${SECONDARY_BOX_SHADOW_COLOR} 0px 0px 5px inset`,
      };
    })(),
    secondary: (() => {
      const PRIMARY_BOX_SHADOW_COLOR = 'rgba(0, 0, 0, 0.3)';
      const SECONDARY_BOX_SHADOW_COLOR = 'rgba(255, 255, 255, 0.5)';

      return {
        primaryColor: PRIMARY_BOX_SHADOW_COLOR,
        secondaryColor: SECONDARY_BOX_SHADOW_COLOR,
        main: `1px 1px 2px ${PRIMARY_BOX_SHADOW_COLOR}, -2px -2px 2px ${SECONDARY_BOX_SHADOW_COLOR}`,
        inset: `inset 1px 1px 2px ${PRIMARY_BOX_SHADOW_COLOR}, inset -2px -2px 2px ${SECONDARY_BOX_SHADOW_COLOR}`,
      };
    })(),
    tertiary: (() => {
      const SECONDARY_BOX_SHADOW_COLOR = 'rgba(0, 0, 0, 0.3)';
      const PRIMARY_BOX_SHADOW_COLOR = 'rgba(255, 255, 255, 0.5)';

      return {
        primaryColor: PRIMARY_BOX_SHADOW_COLOR,
        secondaryColor: SECONDARY_BOX_SHADOW_COLOR,
        main: `2px 2px 2px ${PRIMARY_BOX_SHADOW_COLOR}, -1px -1px 2px ${SECONDARY_BOX_SHADOW_COLOR}`,
        inset: `inset 1px 1px 2px ${PRIMARY_BOX_SHADOW_COLOR}, inset -2px -2px 2px ${SECONDARY_BOX_SHADOW_COLOR}`,
      };
    })(),
  },
  dividers: {
    light: `0.67px solid rgba(0,0,0, 0.1)`,
    main: `0.67px solid rgba(0,0,0, 0.2)`,
    dark: `0.67px solid rgba(0,0,0, 0.5)`,
  },
  fontSizes: {
    h1: '1.7rem',
    h2: '1.6rem',
    h3: '1.25rem',
    h4: '1rem',
    h5: '0.875rem',
    h6: '0.813rem',
    label: '0.75rem',
  },
  transitions: {
    primary: '0.3s cubic-bezier(0, 0.62, 0.5, 0.99)',
  },
  fontFamily: {
    primary: 'museo-sans, sans-serif',
  },
  breakPoints: {
    values: {
      xs: '18.75em', // 300px
      phone: '28.125em', // 450px
      sm: '37.5em', // 600px
      md: '56.25em', // 900px
      desktop: '75em', // 1200px
      lg: '75em', // 1200px
      xl: '96em', // 1536px
    },
  },
  palette: {
    job: {
      accounting: {
        invoiced: '#108e63',
        billed: '#dd7700',
      },
      transport: {
        background: '#0747A6',
      },
      service: {
        background: '#FF8003',
      },
    },
    order: {
      background: '#162A4C',
    },
    common: {
      white: '#fff',
      black: '#000',
    },
    stop: {
      type: {
        pickup: '#36B37E',
        delivery: '#FF5630',
        service: '#6554C0',
      },
    },
    text: {
      primary: '#172B4D',
      secondary: '#FFF',
      tertiary: '',
    },
    background: {
      primary: '#172B4D',
      secondary: '#EBECF0',
      tertiary: '',
    },
    primary: {
      main: '#0052CC',
      light: '#0065FF',
      dark: '#0747A6',
    },
    secondary: {
      main: '#DFE1E6',
      light: '#EBECF0',
      dark: '#6B778C',
    },
    tertiary: {
      main: '#6554C0',
      light: '#8777D9',
      dark: '#5243AA',
    },
    error: {
      main: '#DE350B',
      light: '#FF5630',
      dark: '#BF2600',
    },
    warning: {
      main: '#FF991F',
      light: '#FFAB00',
      dark: '#FF8B00',
    },
    info: {
      main: '#00A3BF',
      light: '#00B8D9',
      dark: '#008DA6',
    },
    success: {
      main: '#00875A',
      light: '#36B37E',
      dark: '#006644',
    },
    action: {
      primary: '#0052CC',
      secondary: '',
      tertiary: '',
    },
    loadboard: {
      superDispatch: '#D86C00',
      centralDispatch: '#1A2231',
      shipCars: '#AF17FF',
      dat: '#00259F',
      truckStop: '#A71B1B',
      trukt: '#172B4D',
    },
  },
  spacing: {
    primary: '1rem',
    secondary: '0.5rem',
    tertiary: '0.2rem',
  },
  iconSizes: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
  },
};

export const defaultTheme = createTheme(initialTheme);
